import { render, staticRenderFns } from "./dayMilkTable.vue?vue&type=template&id=2778e4e9&scoped=true"
import script from "./dayMilkTable.vue?vue&type=script&lang=js"
export * from "./dayMilkTable.vue?vue&type=script&lang=js"
import style0 from "./dayMilkTable.vue?vue&type=style&index=0&id=2778e4e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778e4e9",
  null
  
)

export default component.exports